import type { TranslationKey } from "../../../localization/translations"

export enum InfoDisplayType {
    MENU = "MENU",
    PRODUCTION = "PRODUCTION",
}

/** The card filter above the grid: ALL plus the display types. */
export enum InfoDisplayFilter {
    ALL = "ALL",
    MENU = "MENU",
    PRODUCTION = "PRODUCTION",
}

/** One display card on the info displays page. */
export type InfoDisplay = Readonly<{
    id: string
    type: InfoDisplayType
    nameId: TranslationKey
    nameFallback: string
    descriptionId: TranslationKey
    descriptionFallback: string
    /** The link the display device or intranet embed uses; needs a real device secret. */
    publicUrl: string
    /** Only the intranet menu is meant to be iframed; screens just get the permalink. */
    isEmbeddable: boolean
    /** Texts of the card's link dialog (`.dialogTitle` + `.subtitle`, the subtitle explains who can open the link). */
    linkDialogTextsId: TranslationKey
}>
